import { render, staticRenderFns } from "./ActionStats.vue?vue&type=template&id=127ffb85&"
import script from "./ActionStats.vue?vue&type=script&lang=js&"
export * from "./ActionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports